var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3333 2C16.8856 2 17.3333 2.44772 17.3333 3V4.70892C22.9789 5.18818 27.4785 9.68775 27.9577 15.3333H29.6667C30.2189 15.3333 30.6667 15.781 30.6667 16.3333C30.6667 16.8856 30.2189 17.3333 29.6667 17.3333H27.9577C27.4785 22.9789 22.9789 27.4785 17.3333 27.9577V29.6667C17.3333 30.2189 16.8856 30.6667 16.3333 30.6667C15.781 30.6667 15.3333 30.2189 15.3333 29.6667V27.9577C9.68775 27.4785 5.18818 22.9789 4.70892 17.3333H3C2.44772 17.3333 2 16.8856 2 16.3333C2 15.781 2.44772 15.3333 3 15.3333H4.70892C5.18818 9.68775 9.68775 5.18818 15.3333 4.70892V3C15.3333 2.44772 15.781 2 16.3333 2ZM16.3333 6.66667C10.9946 6.66667 6.66667 10.9946 6.66667 16.3333C6.66667 21.6721 10.9946 26 16.3333 26C21.6721 26 26 21.6721 26 16.3333C26 10.9946 21.6721 6.66667 16.3333 6.66667ZM16.3333 13.3333C14.6765 13.3333 13.3333 14.6765 13.3333 16.3333C13.3333 17.9902 14.6765 19.3333 16.3333 19.3333C17.9902 19.3333 19.3333 17.9902 19.3333 16.3333C19.3333 14.6765 17.9902 13.3333 16.3333 13.3333ZM11.3333 16.3333C11.3333 13.5719 13.5719 11.3333 16.3333 11.3333C19.0948 11.3333 21.3333 13.5719 21.3333 16.3333C21.3333 19.0948 19.0948 21.3333 16.3333 21.3333C13.5719 21.3333 11.3333 19.0948 11.3333 16.3333Z",
    fill: "#C8BCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsLight);
export default __webpack_public_path__ + "static/media/leads_light.bc432c3c9215bd63946ec07378f0ebbe.svg";
export { ForwardRef as ReactComponent };